<style lang="scss" scoped>
.title {
  display: flex;
  margin-bottom: 24px;
  width: 1200px;
  height: 60px;
  background: #ffffff;
  border-radius: 2px;
  padding: 0 24px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  border-top: solid 1px #f0f2f5;
  justify-content: space-between;
  line-height: 60px;
  margin-top: 80px;
  .text {
  }
}
</style>
<template>
  <div class="title">
    <div class="text">
      当前：{{ title }}
    </div>
    <div>
      <el-button
        size="mini"
        @click="back"
      >
        显示上一步
      </el-button>
      <el-button
        type="primary"
        size="mini"
        @click="next"
      >
        {{ desc }}
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BtnBar',
  props: {
    title: {
      type: String,
      default: '第一步 授权客户联系权限'
    },
    desc: {
      type: String,
      default: '授权通讯录'
    },

    toPath: {
      type: String,
      default: '/qwAuth/configApp'
    },
    images: {
      type: String,
      default: 'https://b-uat.jusstickets.com//static/img/logo2.e0ee6fe.jpg'
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  watch: {},
  mounted () {},
  methods: {
    back () {
      this.$confirm('注意：返回上一页当前页编辑项目将会丢失！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.scrollTo( 0, 0 );
        this.$router.go(-1)
      })
    },
    next () {
      console.log('next-this.$parent', this.$parent)
      window.scrollTo( 0, 0 );
      this.$parent.subConfig()
    }
  }
}
</script>
